var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row reports-performer-summary" }, [
    _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("table-resume", {
              attrs: {
                title: _vm.title,
                route: _vm.route,
                externalFilters: _vm.filters,
                extraQueryParams: _vm.extraQueryParams,
                autoUpdateExternalFilter: _vm.autoUpdateExternalFilter,
                autoUpdateFilter: true,
                settings: _vm.settings,
                columns: _vm.columns,
                loadingMsg: _vm.loadingMsg,
                notFoundMsg: _vm.notFoundMsg,
                orderByTemplate: _vm.orderByTemplate,
                confirmExportData: false,
                allowExportData: _vm.allowExportData,
                titleExportData: _vm.titleExportData,
                confirmMsgExportData: _vm.confirmMsgExportData,
                errorMsgExportData: _vm.errorMsgExportData,
                showPagination: false,
                tableWrapperClass: "bg-lilac-light",
                tableClass: "table-responsive-sm",
                funcExportData: _vm.onExport,
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function ({ row, index }) {
                    return [
                      _c("td", [_vm._v(_vm._s(row.name))]),
                      _vm._v(" "),
                      _vm._l(_vm.columns, function (column, idx) {
                        return column.id
                          ? _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.getValueFromItem(row.states, column)
                                  ) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e()
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }